import { useState, useEffect, useRef } from 'react'
import { useNavigate } from '@tanstack/react-router'

export function useDebouncedSearch(props: { initialValue: string; delay?: number }) {
  const delay = props.delay ?? 300

  const navigate = useNavigate()
  const [searchInput, setSearchInput] = useState(props.initialValue)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  // Sync local input with URL when URL changes (e.g., browser back/forward)
  useEffect(() => {
    setSearchInput(props.initialValue)
  }, [props.initialValue])

  // Handle search input with debounce - update URL which triggers query
  const handleSearchChange = (value: string) => {
    setSearchInput(value)

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      navigate({
        to: '.',
        search: (prev) => ({ ...prev, q: value }),
        replace: true,
      })
    }, delay)
  }

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [])

  return {
    searchInput,
    handleSearchChange,
  }
}
